(function errorsServiceDefinition() {

    'use strict';

    angular.module('ErrorsExtend', ['Messages'])
        .provider('errorsExtend', function errorsProvider() {

            this.$get = ['messages', '$state',
                function (messages, $state) {

                    function processMsj(data) {
               
                        return data.statusText || data;
                    }

                    var svc = Object.create(messages);
                    
                    svc.showWarning = function (text, params) {
                        messages.show(text, 'warning', params);
                        return;
                    };

                    svc.showSuccess = function (text, title, params) {
                        if (text && text.data) {
                            return messages.show(text.data.key, 'success', text.data.value);
                        } else {
                            return messages.showSuccess(text, title, params);
                        }
                    }

                    svc.showError = function (error) {
                        if (error.status === 403) {
                            messages.show(processMsj(error.data), error.status);
                            $state.go('inicio');
                            return;
                        }

                        if (error.status === 0 || error.status === -1) {
                            messages.show('APIError');
                            $state.go('inicio');
                            return;
                        }
                        if (error.status === 204) {
                            messages.show('APINoConten');
                            return;
                        }

                        if (!error.data) {
                            messages.show(processMsj(error), error.status);
                            return;
                        }

                        if (error.data.modelState) {
                            if (error.data.modelState.error && error.data.modelState.error.length > 0) {
                                messages.show(processMsj(error.data.modelState.error[0]), error.status);
                            } else {
                                for (var key in error.data.modelState) {
                                    if (error.data.modelState[key].length > 0) {
                                        messages.show(error.data.modelState[key][0], error.status);
                                        break;
                                    }

                                    if (error.data.modelState.hasOwnProperty(key)) {
                                        messages.show(key.toUpperCase(), error.status);
                                        break;
                                    }
                                }
                            }
                        } else if (error.data.exceptionMessage) {
                            messages.show(processMsj(error.data.exceptionMessage), error.status, null);
                        } else {
                            messages.show(error.data.key, error.status, error.data.value);
                        }
                    };

                    return svc;
                }
            ];
        });
})();